import { Modal } from "@risalabs_frontend_org/oasis-ui-kit";
import { ModalId } from "../../../enums/modalId";
import { CommonLiterals } from "../../../enums/StringLiterals/commonLiterals";
import WarningIcon from "../../../svg/warningIcon";

interface SftpRerunProps {
  onClose: () => void;
  onSave: () => void;
  isRunning?: boolean;
}

const SftpRerun = (props: SftpRerunProps) => {
  const saveButtonText = props.isRunning ? "Running..." : "Rerun";

  return (
    <Modal
      dialogId={ModalId.SFTP_RERUN_MODAL}
      title="Rerun SFTP "
      onClose={props.onClose}
      onSave={props.isRunning ? () => {} : props.onSave}
      saveButtonText={saveButtonText}
      disableSave={props.isRunning}
      cancelText="Cancel"
    >
      <div className="flex flex-col items-center justify-center gap-4 p-4">
        <WarningIcon />
        <div className="text-primaryGray3 text-center text-h12 font-normal">
          {CommonLiterals.RE_RUN_MODAL_TEXT}
        </div>
      </div>
    </Modal>
  );
};

export default SftpRerun;
